import { useEffect, useId, useRef, type ReactNode } from "react";

type ModalProps = {
  title: string;
  eyebrow?: string;
  children: ReactNode;
  onClose: () => void;
  wide?: boolean;
  className?: string;
};

export function Modal({ title, eyebrow, children, onClose, wide, className = "" }: ModalProps) {
  const backdropRef = useRef<HTMLDivElement>(null);
  const titleId = useId();
  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      const layers = document.querySelectorAll(".modal-backdrop");
      if (event.key === "Escape" && layers[layers.length - 1] === backdropRef.current) onClose();
    };
    document.addEventListener("keydown", handler);
    document.body.classList.add("modal-open");
    return () => {
      document.removeEventListener("keydown", handler);
      if (![...document.querySelectorAll(".modal-backdrop")].some(layer => layer !== backdropRef.current)) document.body.classList.remove("modal-open");
    };
  }, [onClose]);

  return (
    <div ref={backdropRef} className="modal-backdrop" role="presentation">
      <section className={["modal-card", wide ? "modal-wide" : "", className].filter(Boolean).join(" ")} role="dialog" aria-modal="true" aria-labelledby={titleId}>
        <header className="modal-header">
          <div>
            {eyebrow && <span className="eyebrow">{eyebrow}</span>}
            <h2 id={titleId}>{title}</h2>
          </div>
          <button className="icon-button" type="button" onClick={onClose} aria-label="Cerrar">×</button>
        </header>
        <div className="modal-body">{children}</div>
      </section>
    </div>
  );
}
